import { AxiosHeaders, AxiosRequestConfig, AxiosResponse } from 'axios'
import { API_HOST } from '../constants'
import { PrevAxios } from '../prev-front-mf-api'
import { AuthDeleteProps } from './types'
import { getToken, handleError } from './utils'

export const authGet = async (path: string, host = API_HOST, config?: any): Promise<AxiosResponse | undefined> => {
  const token = `Bearer ${getToken()}`
  try {
    const url = `${host}${path}`
    const response = await PrevAxios.get(url, {
      ...config,
      headers: {
        Authorization: token,
        ...config?.headers,
      },
    })
    return response
  } catch (error) {
    handleError(error)
  }
}

export const authPut = async ({
  path,
  host = API_HOST,
  data,
  config = {},
}: {
  path: string
  host?: string
  data?: any
  config?: any
}): Promise<AxiosResponse | undefined> => {
  const accessToken = `Bearer ${getToken()}`
  try {
    const url = `${host}${path}`
    const response = await PrevAxios.put(url, data, {
      ...config,
      headers: {
        Authorization: accessToken,
        ...config?.headers,
      },
    })
    return response
  } catch (error) {
    handleError(error)
  }
}

export const authPost = async <T, K>({
  path,
  host = API_HOST,
  data,
  headers,
  config,
}: {
  path: string
  host?: string
  data: T
  headers?: AxiosHeaders
  config?: AxiosRequestConfig
}): Promise<AxiosResponse | undefined> => {
  try {
    const accessToken = `Bearer ${getToken()}`
    const url = `${host}${path}`
    const response = await PrevAxios.post(url, data, {
      ...config,
      headers: {
        Authorization: accessToken,
        ...headers,
      },
    })

    return response
  } catch (error) {
    handleError(error)
  }
}

export const authDelete = async (props: AuthDeleteProps): Promise<AxiosResponse | undefined> => {
  try {
    const { path, host = API_HOST } = props
    const accessToken = `Bearer ${getToken()}`
    const response = await PrevAxios.delete(`${host}${path}`, {
      headers: {
        Authorization: accessToken,
      },
    })
    return response
  } catch (error) {
    handleError(error)
  }
}

